import Box from "./Box";
import HeadingSmall from "./HeadingSmall";
import Image from "./Image";
import PropTypes from "prop-types";
import { RESPONSIVE } from "../core/constants";
import React from "react";
import Text from "./Text";

function Quote({ quote, quoteSource, quoteImage }) {
  return (
    <Box display={[null, null, "flex", null]} maxWidth={1000} mx="auto">
      {quoteImage && (
        <Box
          borderRadius="100%"
          width={90}
          height={90}
          mr={[null, null, 40, null]}
          mb={[40, null, 0, null]}
          flexShrink={0}
          mx="auto"
          overflow="hidden"
        >
          <Image
            src={quoteImage.url}
            alt={quoteImage.title}
            width="100%"
            height="100%"
            borderRadius="100%"
            objectFit="cover"
            imgHeight={90}
            imgWidth={90}
            layout={RESPONSIVE}
            bg="lightGrey"
          />
        </Box>
      )}
      <Box>
        <HeadingSmall italic>{`“${quote}”`}</HeadingSmall>
        <Text
          fontSize={[14, 14, 14, 14]}
          lineHeight={("24px", "24px", "24px", "24px")}
          uppercase
          fontWeight={700}
          pt={15}
        >
          {quoteSource}
        </Text>
      </Box>
    </Box>
  );
}

export default Quote;

Quote.propTypes = {
  quote: PropTypes.string.isRequired,
  quoteSource: PropTypes.string.isRequired,
  quoteImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};
